"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDestinationBridge = exports.DestinationBridgeContext = void 0;
var DestinationBridgeContext_1 = require("./DestinationBridgeContext");
Object.defineProperty(exports, "DestinationBridgeContext", { enumerable: true, get: function () { return DestinationBridgeContext_1.DestinationBridgeContext; } });
Object.defineProperty(exports, "useDestinationBridge", { enumerable: true, get: function () { return DestinationBridgeContext_1.useDestinationBridge; } });
//# sourceMappingURL=index.js.map